package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device.ListDeviceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ListDeviceRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import com.varabyte.kobweb.browser.http.AbortController

class ListDeviceRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
) : ListDeviceRepository {
    
    private var abortController: AbortController? = null
    
    override suspend fun getListDevices(model: String): ListDeviceModel {
        abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                query listDevices(${'$'}params: ListQueryArgs, 
                ${'$'}model: String, ${'$'}software: String) {
                  listDevices(filter: {model: ${'$'}model, software:
                   ${'$'}software}, params: ${'$'}params) {
                    cursors {
                      ${ApiUtils.Field.after}
                      ${ApiUtils.Field.hasNext}
                      ${ApiUtils.Field.__typename}
                    }
                    items {
                      ${ApiUtils.Field.hardwareId}
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }
            """.trimIndent())

            putJsonObject("variables") {
                put("model", model)
                putJsonObject("params") {
//                    putJsonObject("cursors") {
//                        put("before", "W040MTEyMjdGMDA2MTJd")
//                        put("after", "W040MTEyMjdGMDA2MTJd")
//                    }
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
    
    override fun cancel() {
        abortController?.abort()
        abortController = null
    }
} 